export interface IWeinreContainer {
	__weinreLoaded?: boolean;
	document: Document;
}

export function startWeinreDebug(global: IWeinreContainer) {
	if (!global.__weinreLoaded) {
		const script = global.document.createElement('script');
		script.src = 'weinre.js';
		document.body.appendChild(script);

		global.__weinreLoaded = true;
	}
}
